<template>
  <div id="app">
    <v-app>
      <v-toolbar app dark color="primary">
        <v-toolbar-side-icon to="/"></v-toolbar-side-icon>
        <div class="mx-auto"><img src="/img/logo.png" class="mt-2 mr-5"/></div>
      </v-toolbar>
      <v-content>
        <p class="text-xs-center mt-1 mb-0" v-if="lastUpdate">Actualisé au {{ lastUpdate | moment('L')}}

        </p>

          <router-view></router-view>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'App',
  data() {
    return {

    }
  },
  computed: {
    ...mapState(['lastUpdate']),
  },
}
</script>


<style>
.container.grid-list-md {
  padding: 12px;
}

.card.border-left{
  border-left: solid 5px currentColor;
  background-color: white !important;
}

.card:not(.card--flat) {
  box-shadow: 0 1px 2px 0px rgba(0,0,0,.10),
    0 1px 3px 0 rgba(0,0,0,.10);
}

.icon-chip {
  min-width: 54px;
  justify-content: center;
}

.card .main-data {
  font-size:18px;
  font-weight: 600;
}

.progress-chart {
  position: relative;
  margin:auto;
}

.progress-chart canvas{
  display: inline !important;
}

.progress-chart .label {
  position:absolute;
  top: -2px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  text-align: center;
}

.progress-chart .label:before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}

.edit .input-group__details {
  min-height: 0px;
}

.italic {
  font-style: italic;
}

.legend {
  list-style-type: none;
}

.legend li {
  display: inline;
  margin-right: 20px;
}

.legend-color {
  display: inline-block;
  width: 25px;
  height: 10px;
  margin-right: 10px
}
</style>
